exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.view-enter-active, view-leave-active {\n    transition: opacity 0.5s\n}\n.view-leave-active {\n    position:absolute;\n}\n.view-enter, .view-leave-to {\n    opacity:0;\n}\n", ""]);

// exports
